module.exports = __webpack_public_path__ + "static/media/INBOUND@2x.e095058b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/INBOUND@2x.png
// module id = 83
// module chunks = 0